let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("az3gU")).then(() => parcelRequire('XhTSt'));